/* eslint-disable camelcase */
import i18next from 'i18next';

i18next.addResources('pt_PT', 'NIF', {
  title: 'Adicionar fatura'
});
